import React from 'react';
import './App.css';
import Header from './components/Header';
import About from './components/About';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Languages from './components/Languages';
import Navigation from './components/Navigation';
import Projects from './components/Projects';
import Certifications from './components/Certifications';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { faBars, faHouse, faDatabase } from '@fortawesome/free-solid-svg-icons';
import { faSalesforce, faSquareJs, faReact, faNodeJs, faHtml5, faCss3, faGitAlt } from '@fortawesome/free-brands-svg-icons';

library.add(fab, faBars, faHouse, faDatabase, faSalesforce, faSquareJs, faReact, faNodeJs, faHtml5, faCss3, faGitAlt);

function App() {
  //not let save my images
  document.addEventListener('contextmenu', (event) => {
    event.preventDefault();
  });
  document.onkeydown = function (e) {
    if (e.ctrlKey && (e.keyCode === 67 || e.keyCode === 86 || e.keyCode === 85 || e.keyCode === 117)) {//Prevent Ctrl+C, Ctrl+V, Ctrl+U, F12
      return false;
    } else {
      return true;
    }
  };
  return (
    <div className="App">
      <Navigation />
      <main>
        <Header />
        <About id="about" />
        <Languages id="languages" />
        <Experience id="experience" />
        <Skills id="skills" />
        <Certifications id="certifications" />
        <Projects id="projects" />
        <Contact id="contact" />
      </main>
      <footer>
        <p>&copy; {new Date().getFullYear()} Antia Julia Alaman Martinez</p>
      </footer>
    </div>
  );
}

export default App;
